import { render, staticRenderFns } from "./inkhubMonthly.vue?vue&type=template&id=6d390755&scoped=true"
import script from "./inkhubMonthly.vue?vue&type=script&lang=js"
export * from "./inkhubMonthly.vue?vue&type=script&lang=js"
import style0 from "./inkhubMonthly.vue?vue&type=style&index=0&id=6d390755&lang=scss&scoped=true"
import style1 from "./inkhubMonthly.vue?vue&type=style&index=1&id=6d390755&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d390755",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-manage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d390755')) {
      api.createRecord('6d390755', component.options)
    } else {
      api.reload('6d390755', component.options)
    }
    module.hot.accept("./inkhubMonthly.vue?vue&type=template&id=6d390755&scoped=true", function () {
      api.rerender('6d390755', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/inkhubMonthly.vue"
export default component.exports